/** Ключи словаря. Один источник правды: en — эталон, остальные обязаны совпасть. */
export const LANGS = [
  "en",
  "ru",
  "de",
  "fr",
  "es",
  "pt",
  "it",
  "nl",
  "pl",
  "cs",
  "ro",
  "uk",
  "tr",
  "el",
  "sv",
  "id",
  "hi",
  "ja",
  "ko",
  "zh",
] as const;

export type Lang = (typeof LANGS)[number];

/** Родные названия — для переключателя, а не переведённые. */
export const LANG_NAMES: Record<Lang, string> = {
  en: "English",
  ru: "Русский",
  de: "Deutsch",
  fr: "Français",
  es: "Español",
  pt: "Português",
  it: "Italiano",
  nl: "Nederlands",
  pl: "Polski",
  cs: "Čeština",
  ro: "Română",
  uk: "Українська",
  tr: "Türkçe",
  el: "Ελληνικά",
  sv: "Svenska",
  id: "Bahasa Indonesia",
  hi: "हिन्दी",
  ja: "日本語",
  ko: "한국어",
  zh: "中文",
};

export interface Dict {
  city: string;
  pick: string;
  picking: string;
  here: string;
  here_name: string;
  reading: string;
  queue: string;
  contUp: string;
  cities: string;
  citiesNote: string;
  heard: string;
  feels: string;
  wind: string;
  cloud: string;
  precip: string;
  pressure: string;
  kmh: string;
  mmh: string;
  hpa: string;
  themeLight: string;
  themeDark: string;
  themeSystem: string;
  play: string;
  pause: string;
  prevTrack: string;
  nextTrack: string;
  volume: string;
  installTitle: string;
  installWhy: string;
  installYes: string;
  installNo: string;
  looping: string;
  retrying: string;
  notFound: string;
  didYouMean: string;
  noGeo: string;
  geoDenied: string;
  failed: string;
  noCandidates: string;
  geocodeDown: string;
  errThrottled: string;
  errEmpty: string;
  errNoKey: string;
  errHttp: string;
  errApi: string;
  viaArchive: string;
  byProfile: string;
  credits: string;
  grey_streak: string;
  temp_drop: string;
  temp_rise: string;
  anomaly_warm: string;
  anomaly_cold: string;
  hot: string;
  warm: string;
  cool: string;
  cold: string;
  frost: string;
  clear_day: string;
  clear_night: string;
  overcast: string;
  snow: string;
  heavy_rain: string;
  rain: string;
  rain_wet: string;
  fog: string;
  storm: string;
  windy: string;
  night: string;
  golden_hour: string;
  pressure_falling: string;
  pressure_rising: string;
  clearing: string;
  worsening: string;
  c_blizzard: string;
  c_night_rain: string;
  c_long_grey: string;
  c_blaze: string;
  c_bright_frost: string;
  c_night_storm: string;
  c_foul: string;
  c_cold_fog: string;
  c_golden: string;
  c_odd_warm: string;
  c_front: string;
  c_turn_cold: string;
  "speed:verylow": string;
  "speed:low": string;
  "speed:medium": string;
  "speed:high": string;
  "speed:veryhigh": string;
  "vocal:instrumental": string;
  "vocal:vocal": string;
  "acoustic:acoustic": string;
  "acoustic:electric": string;
}
